import http from '@/utils/http';
const call=async(action,data)=>{const res=await http({url:'/api/admin/v1/contractProjectPriceUpgrade/'+action,method:'post',data});if(res?.code!==0)throw Error(res?.msg||res?.message||'完整价表升级处理失败');return res.data;};
export default Object.fromEntries(['detail','copy','propose','confirm','reject','withdraw','signStart','signSync','signRetry'].map(action=>[action,data=>call(action,data)]));

export const upgradeFile=data=>http({url:'/api/admin/v1/contractProjectPriceUpgrade/file',method:'get',data,responseType:'blob'});
